import { waitAsync } from '../utils';
import { Route } from 'react-router-dom';

const ModifyTradeAction = "MODIFY_TRADE";
const ListTradesAction = "LIST_TRADES";
const CancelTradeAction = "CANCEL_TRADE";
const Waiting = "WAITNG_TRADES";

const initialState = {
    list: [],
    nowWainting: false,
    editing: null
};
export const actionCreators = {
    /**
     * 取引一覧を取得します。
     */
    listTrades: (token, searchStartDt, searchEndDt, searchStartAmount, searchEndAmount, searchMerchantName, searchShopName, searchTransactionType, searchAccountType, searchPaymentNo, searchTerminalId, searchUnfinishType) => async (dispatch) => {
        const routeurl = `api/user/trades/list`;

        var param = '';
        // 日時(開始)
        if (searchStartDt != "" && searchStartDt != null && searchStartDt != undefined) {
            if (param == '') {
                param += '?';
            }
            else {
                param += '&';
            }
            // UTC変換
            const dt = new Date(searchStartDt);
            var utcDt = dt.toISOString();
            param += `sdt=${utcDt}`;
        }
        // 日時(終了)
        if (searchEndDt != "" && searchEndDt != null && searchEndDt != undefined) {
            if (param == '') {
                param += '?';
            }
            else {
                param += '&';
            }
            // UTC変換
            const dt = new Date(searchEndDt);
            var utcDt = dt.toISOString();
            param += `edt=${utcDt}`;
        }
        // 価格(開始)
        if (searchStartAmount != "" && searchStartAmount != null && searchStartAmount != undefined) {
            if (param == '') {
                param += '?';
            }
            else {
                param += '&';
            }
            param += `samount=${searchStartAmount}`;
        }
        // 価格(終了)
        if (searchEndAmount != "" && searchEndAmount != null && searchEndAmount != undefined) {
            if (param == '') {
                param += '?';
            }
            else {
                param += '&';
            }
            param += `eamount=${searchEndAmount}`;
        }
        // 加盟店名
        if (searchMerchantName != "" && searchMerchantName != null && searchMerchantName != undefined) {
            if (param == '') {
                param += '?';
            }
            else {
                param += '&';
            }
            param += `mname=${searchMerchantName}`;
        }
        // 店舗名
        if (searchShopName != "" && searchShopName != null && searchShopName != undefined) {
            if (param == '') {
                param += '?';
            }
            else {
                param += '&';
            }
            param += `sname=${searchShopName}`;
        }
        // 取引タイプ
        if (searchTransactionType != "" && searchTransactionType != null && searchTransactionType != undefined) {
            if (param == '') {
                param += '?';
            }
            else {
                param += '&';
            }
            param += `ttype=${searchTransactionType}`;
        }
        // 決済種別
        if (searchAccountType != "" && searchAccountType != null && searchAccountType != undefined) {
            if (param == '') {
                param += '?';
            }
            else {
                param += '&';
            }
            param += `atype=${searchAccountType}`;
        }
        // 未了種別
        if (searchUnfinishType != "" && searchUnfinishType != null && searchUnfinishType != undefined) {
            if (param == '') {
                param += '?';
            }
            else {
                param += '&';
            }
            param += `utype=${searchUnfinishType}`;
        }

        // 決済番号
        if (searchPaymentNo != "" && searchPaymentNo != null && searchPaymentNo != undefined) {
            if (param == '') {
                param += '?';
            }
            else {
                param += '&';
            }
            param += `pno=${searchPaymentNo}`;
        }
        // 端末機識別番号
        if (searchTerminalId != "" && searchTerminalId != null && searchTerminalId != undefined) {
            if (param == '') {
                param += '?';
            }
            else {
                param += '&';
            }
            param += `tid=${searchTerminalId}`;
        }

        dispatch({ type: Waiting, nowWainting: true });

        try {

            let response = await fetch(routeurl + param, {
                method: 'get',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
            })

            const resultStatus = response.status;

            if (resultStatus == 200) {
                const list = await response.json();
                dispatch({ type: ListTradesAction, list });
                return list;
            } else {
                throw new Error('取引一覧取得に失敗しました。');
            }
        } finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },

    /**
     * 取引情報を編集します。
     */
    modifyTrade: (trade) => async (dispatch) => {
        dispatch({ type: ModifyTradeAction, trade, nowWainting: false });
    },

    /**
     * 編集用のモデルをロードします。
     */
    loadEditModel: (token, tradeId) => async (dispatch) => {
        var routeurl = `api/user/trades/edit`;

        if (tradeId != null) {
            routeurl += `?id=${tradeId}`;
        }

        dispatch({ type: Waiting, nowWainting: true });

        try {

            let response = await fetch(routeurl, {
                method: 'get',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
            })
            const resultStatus = response.status;
            if (resultStatus == 200) {
                const trade = await response.json();
                dispatch({ type: ModifyTradeAction, trade });
                return trade;
            } else {
                throw new Error('取引情報取得に失敗しました。');
            }
        }
        finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },

    /**
     * 指定の取引IDが取り消されているか判定します。
     */
    IsCancelTrade: (token, tradeId) => async (dispatch) => {
        var routeurl = `api/user/trades/is_cancel`;

        if (tradeId != null) {
            routeurl += `?id=${tradeId}`;
        }

        dispatch({ type: Waiting, nowWainting: true });

        try {

            let response = await fetch(routeurl, {
                method: 'get',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
            })

            const resultStatus = response.status;
            if (resultStatus == 200) {
                const resp = await response.json();
                if (resp.error_message == null) {
                    return resp.result;
                } else {
                    throw new Error(resp.error_message || '取消判定の取得に失敗しました。');
                }
            } else {
                throw new Error('取消判定の取得に失敗しました。');
            }
        }
        finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },

    /**
     * 取引情報を設定します。
     */
    setTradeInfo: (trade) => async (dispatch) => {
        dispatch({ type: ModifyTradeAction, trade, nowWainting: false });
    },

    /**
     * 取引一覧を初期化します。
     */
    initListInfo: () => async (dispatch) => {
        dispatch({ type: ListTradesAction, list: [], nowWainting: false });
    },

    /**
     * 取引情報の取消を行います。
     */
    cancel: (token, trade) => async (dispatch) => {
        var routeurl = `api/user/trades/cancel`;

        dispatch({ type: Waiting, nowWainting: true });

        try {
            let response = await fetch(routeurl, {
                method: 'post',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
                body: JSON.stringify(trade)
            })

            const resultStatus = response.status;

            if (resultStatus == 200) {
                const resp = await response.json();

                if (resp.error_message == null) {

                    dispatch({ type: CancelTradeAction, trade: resp.result });
                    return resp.result;

                } else {
                    throw new Error(resp.error_message || '取消に失敗しました。');
                }
            } else {
                throw new Error('取消に失敗しました。');
            }
        } finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },
}

export const reducer = (state, action) => {
    state = state || initialState;
    
    if (action.type === Waiting) {
        return {
            ...state,
            nowWainting: action.nowWainting
        };
    }
    if (action.type === ModifyTradeAction) {
        return {
            ...state,
            editing: action.trade,
            nowWainting: action.nowWainting
        };
    }
    if (action.type === ListTradesAction) {
        return {
            ...state,
            list: action.list,
            nowWainting: action.nowWainting
        };
    }
    // 取消
    if (action.type === CancelTradeAction) {
        // 取消の場合はリストから除去
        state.list = state.list.filter((o) => o.id != action.trade.id);

        return {
            ...state,
            editing: action.trade
        };
    }
   return state;
}